import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function CountUp({
  end,
  suffix = ''
}: {
  end: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [inView, end]);
  return <span ref={ref} data-id="element-135">
      {count}
      {suffix}
    </span>;
}
const stats = [{
  value: 100,
  suffix: '+',
  label: 'Homes Sold'
}, {
  value: 50,
  suffix: 'M+',
  prefix: '$',
  label: 'In Sales Volume'
}, {
  value: 5,
  suffix: '★',
  label: 'Average Client Rating'
}, {
  value: 10,
  suffix: '+',
  label: 'Years of Experience'
}];
export function MarketStats() {
  return <section className="relative py-24 md:py-32 bg-charcoal overflow-hidden" data-id="element-136">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-fixed bg-cover bg-center opacity-20 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1449844908441-8829872d2607?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
    }} data-id="element-137" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-138">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 text-center" data-id="element-139">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="flex flex-col items-center justify-center" data-id="element-140">
              <div className="font-heading text-4xl md:text-5xl lg:text-6xl text-gold font-bold mb-4 tracking-tighter" data-id="element-141">
                {stat.prefix}
                <CountUp end={stat.value} suffix={stat.suffix} data-id="element-142" />
              </div>
              <div className="font-body text-white/80 uppercase tracking-widest text-xs md:text-sm" data-id="element-143">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}